import { CloseIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import TableLoader from "components/common/TableLoader/TableLoader";
import CustomInput from "components/common/customInput/CustomInput";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";
import {
  dateFilter,
  dateRanges,
  filterIsActive,
  sortBy,
} from "../utils/constant";

const DefineSettings = ({
  activePage,
  data,
  isLoading,
  setFieldValue,
  loadFiltersOptions,
  values,
  isDisabled,
  handleChange,
  settingCreateLoading,
  createWorkflowSettings,
  showError,
  schemaField,
}: any) => {
  return (
    <Box display={activePage === 5 ? undefined : "none"}>
      {/* Search Filter */}

      <Box p={4} rounded={8} borderWidth={1} shadow={"base"}>
        <Text fontWeight="700" color={"teal"} mb={1}>
          Define Search Filter
        </Text>
        {/* <Flex justifyContent="space-between"> */}
        {/* </Flex> */}
        {/* <ShadowBox mt={3}> */}
        <Grid templateColumns={{ md: "1fr 1fr" }} gap={6} mt={2}>
          <FormControl>
            <FormLabel fontSize={"sm"}>Keys</FormLabel>
            <CustomInput
              type="select"
              placeholder="Enter the Key"
              name={`searchFilter.key`}
              options={schemaField}
              value={values?.searchFilter?.key}
              onChange={(e: any) => setFieldValue(`searchFilter.key`, e)}
              disabled={isDisabled}
              rest={{
                width: {
                  base: "10rem",
                  lg: "100%",
                },
              }}
              isBoxSelect={true}
            />
          </FormControl>
          <FormControl>
            <FormLabel fontSize={"sm"}>Active Mode</FormLabel>
            <CustomInput
              disabled={isDisabled}
              type="switch"
              name="searchFilter.isActive"
              // label="Is Active"
              value={values.searchFilter.isActive}
              onChange={(e: any) =>
                setFieldValue(`searchFilter.isActive`, e.target.checked)
              }
            />
          </FormControl>
          {/* <Table variant="simple">
              <Thead>
                <Tr>
                  <Th>Keys</Th>
                  <Th>Active Mode</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                <Td>
                  <CustomInput
                    type="select"
                    placeholder="Enter the Key"
                    name={`searchFilter.key`}
                    options={schemaField}
                    value={values?.searchFilter?.key}
                    onChange={(e: any) => setFieldValue(`searchFilter.key`, e)}
                    disabled={isDisabled}
                    rest={{
                      width: {
                        base: "10rem",
                        lg: "100%",
                      },
                    }}
                    isBoxSelect={true}
                  />
                </Td>
                <Td>
                  <CustomInput
                    disabled={isDisabled}
                    type="switch"
                    name="searchFilter.isActive"
                    // label="Is Active"
                    value={values.searchFilter.isActive}
                    onChange={(e: any) =>
                      setFieldValue(`searchFilter.isActive`, e.target.checked)
                    }
                  />
                </Td>
              </Tbody>
            </Table> */}
        </Grid>
        {/* </ShadowBox> */}
      </Box>

      <Box mt={4} p={5} rounded={8} borderWidth={1} shadow={"base"}>
        <Flex justifyContent="space-between" alignItems="center">
          <Text fontWeight="700" color={"teal"} mb={1}>
            Define Filters
          </Text>
          <Popover placement="left">
            <PopoverTrigger>
              <Button
                // title="Add User"
                bg="teal.400"
                color="white"
                _hover={{ bg: "teal.500" }}
                ml={5}
                h="38px"
                mt="8px"
                isDisabled={isDisabled}
                display="none"
              >
                <FaPlus />
              </Button>
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverCloseButton />
              {/* <PopoverHeader>Add Table</PopoverHeader> */}
              <PopoverBody mt={4}>
                <Box m={1}>
                  <Box
                    bg="teal.100"
                    color="teal.600"
                    fontSize="md"
                    fontWeight="600"
                    m={2}
                    h="3rem"
                    rounded={2}
                    _hover={{ bg: "teal.200", color: "white" }}
                    display="none"
                    alignItems="center"
                    cursor="pointer"
                  >
                    <Text ml={2}>Add Existing Filter</Text>
                  </Box>
                  <Box
                    bg="teal.100"
                    color="teal.600"
                    fontWeight="600"
                    m={2}
                    fontSize="md"
                    h="3rem"
                    rounded={2}
                    _hover={{ bg: "teal.200", color: "white" }}
                    display="flex"
                    alignItems="center"
                    cursor="pointer"
                    onClick={() => {
                      setFieldValue("filters", [
                        ...values.filters,
                        {
                          newAdd: true,
                          placeholder: "Select...",
                          label: `Filter ${values?.filters?.length + 1} `,
                          isActive: true,
                          filters: [
                            {
                              key: "documentId",
                              label: "",
                              isActive: true,
                            },
                          ],
                        },
                      ]);
                    }}
                  >
                    <Text ml={2}>Add New Filter</Text>
                  </Box>
                </Box>
              </PopoverBody>
            </PopoverContent>
          </Popover>
        </Flex>
        <Box>
          <CustomInput
            type="select-async"
            name="table"
            label="Add Existing filter"
            isClear={true}
            getOptionLabel={(option: any) => option.title}
            getOptionValue={(option: any) => option._id}
            loadOptions={(inputValue, callback) =>
              loadFiltersOptions(inputValue, "filters", callback)
            }
            onChange={(e) => {
              if (e?.addNew) {
                setFieldValue("filters", [
                  ...values.filters,
                  {
                    addNew: true,
                    placeholder: "Select...",
                    label: e.title,
                    isActive: true,
                    filters: [
                      {
                        key: "",
                        label: "",
                        isActive: true,
                      },
                    ],
                  },
                ]);
              } else {
                if (e) {
                  setFieldValue("filters", [
                    ...values.filters,
                    { ...e.values, _id: e._id },
                  ]);
                }
              }
            }}
            options={data}
            loading={isLoading}
            placeholder="Search..."
            disabled={isDisabled}
            rest={{
              width: { base: "10rem", lg: "100%" },
            }}
          />
        </Box>
        <FieldArray name="filters">
          {({ remove }) => (
            <Box>
              {Array.from({ length: values?.filters?.length }, (_, indexKey) => (
                <Accordion allowMultiple mt={2}>
                  <AccordionItem>
                    <h2>
                      <AccordionButton bg="teal.50" _hover={{ bg: "teal.100" }}>
                        <Box as="span" flex="1" textAlign="left">
                          {values.filters[indexKey].label}
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4} px={0}>
                      <Box
                        borderWidth={2}
                        rounded={8}
                        mt={2}
                        borderColor={"teal.300"}
                        p={4}
                      >
                        <Flex justifyContent="flex-end">
                          <Box
                            display={{
                              base: "block",
                              md: "none",
                            }}
                          >
                            <Tooltip
                              label="Delete Filter"
                              hasArrow
                              placement="left"
                            >
                              <Button
                                type="button"
                                mt="-8px"
                                color={"red.400"}
                                variant="outline"
                                _hover={{
                                  borderColor: "red.500",
                                  color: "red.600",
                                }}
                                size="sm"
                                onClick={() => remove(indexKey)}
                                isDisabled={isDisabled}
                                rounded={"full"}
                                w="1.75rem"
                              >
                                <CloseIcon />
                              </Button>
                            </Tooltip>
                          </Box>
                        </Flex>
                        <Grid
                          gridTemplateColumns={{
                            md: "1fr 1fr 1fr 1fr 1fr 2rem",
                          }}
                          columnGap={3}
                          mb={4}
                          key={indexKey}
                        >
                          <CustomInput
                            placeholder="Enter the Label"
                            type="text"
                            label="Define the Filter Label"
                            name={`filters[${indexKey}].label`}
                            value={values.filters[indexKey].label}
                            onChange={handleChange}
                            rest={{
                              width: {
                                base: "10rem",
                                lg: "100%",
                              },
                            }}
                            disabled={isDisabled}
                          />
                          <CustomInput
                            label="Placeholder"
                            type="text"
                            placeholder="Enter the Label Placeholder"
                            name={`filters[${indexKey}].placeholder`}
                            value={values.filters[indexKey].placeholder}
                            onChange={handleChange}
                            rest={{
                              width: {
                                base: "10rem",
                                lg: "100%",
                              },
                            }}
                            disabled={isDisabled}
                          />
                          <CustomInput
                            type="select"
                            placeholder="Select Key"
                            name={`filters[${indexKey}].key`}
                            label="Key"
                            value={values.filters[indexKey].key}
                            options={schemaField}
                            onChange={(e: any) =>
                              setFieldValue(`filters[${indexKey}].key`, e)
                            }
                            disabled={isDisabled}
                            rest={{
                              width: {
                                base: "10rem",
                                lg: "100%",
                              },
                            }}
                            isBoxSelect={true}
                          />
                          <CustomInput
                            disabled={isDisabled}
                            type="select"
                            options={filterIsActive}
                            name={`filters[${indexKey}].isActive`}
                            value={values.filters[indexKey].isActive}
                            label="Is Active"
                            onChange={(e: any) =>
                              setFieldValue(`filters[${indexKey}].isActive`, e)
                            }
                            isBoxSelect={true}
                          />
                          <CustomInput
                            disabled={isDisabled}
                            type="select"
                            options={filterIsActive}
                            name={`filters[${indexKey}].isMultiSelect`}
                            value={values.filters[indexKey].isMultiSelect}
                            label="Allow Multi Select"
                            onChange={(e: any) =>
                              setFieldValue(
                                `filters[${indexKey}].isMultiSelect`,
                                e
                              )
                            }
                            isBoxSelect={true}
                          />
                          <Box
                            display={{
                              base: "none",
                              md: "block",
                            }}
                          >
                            <Tooltip
                              label="Delete Filter"
                              hasArrow
                              placement="left"
                            >
                              <Button
                                type="button"
                                mt="-8px"
                                color={"red.400"}
                                variant="outline"
                                _hover={{
                                  borderColor: "red.500",
                                  color: "red.600",
                                }}
                                size="sm"
                                onClick={() => remove(indexKey)}
                                isDisabled={isDisabled}
                                rounded={"full"}
                                w="1.75rem"
                              >
                                <CloseIcon />
                              </Button>
                            </Tooltip>
                          </Box>
                        </Grid>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          mb={3}
                        >
                          <Text fontWeight="500">Define Filters Keys</Text>
                          {values.filters[indexKey]?.filters?.length === 0 && (
                            <Tooltip
                              label="Add Filter"
                              hasArrow
                              placement="left"
                            >
                              <Button
                                onClick={() => {
                                  setFieldValue(
                                    `filters[${indexKey}].filters`,
                                    [
                                      ...values.filters[indexKey].filters,
                                      {
                                        label: "",
                                        key: "",
                                        isActive: true,
                                      },
                                    ]
                                  );
                                }}
                                bg="teal.400"
                                color="white"
                                _hover={{ bg: "teal.500" }}
                                disabled={isDisabled}
                              >
                                <FaPlus />
                              </Button>
                            </Tooltip>
                          )}
                        </Flex>
                        <Box className="customScrollBar" overflowY="auto">
                          <Table variant="simple" size={"sm"}>
                            <Thead>
                              <Tr>
                                <Th>Label</Th>
                                <Th>Keys</Th>
                                <Th>Active Mode</Th>
                                <Th></Th>
                              </Tr>
                            </Thead>
                            <FieldArray name={`filters[${indexKey}].filters`}>
                              {({ remove }) => (
                                <TableLoader
                                  loader={false}
                                  show={values.filters?.length}
                                >
                                  <Tbody>
                                    {values.filters[indexKey]?.filters.map(
                                      (filter: any, index: any) => (
                                        <Tr key={index}>
                                          <Td>
                                            <CustomInput
                                              placeholder="Enter the Label"
                                              type="text"
                                              name={`filters[${indexKey}].filters[${index}].label`}
                                              value={filter.label}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `filters[${indexKey}].filters[${index}].label`,
                                                  e.target.value
                                                )
                                              }
                                              rest={{
                                                width: {
                                                  base: "10rem",
                                                  lg: "100%",
                                                },
                                              }}
                                              disabled={isDisabled}
                                            />
                                          </Td>
                                          <Td>
                                            <CustomInput
                                              placeholder="Enter the Key"
                                              type="text"
                                              name={`filters[${indexKey}].filters[${index}].key`}
                                              value={filter.key}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `filters[${indexKey}].filters[${index}].key`,
                                                  e.target.value
                                                )
                                              }
                                              rest={{
                                                width: {
                                                  base: "10rem",
                                                  lg: "100%",
                                                },
                                              }}
                                              disabled={isDisabled}
                                            />
                                          </Td>
                                          <Td justifyContent={"center"}>
                                            <CustomInput
                                              disabled={isDisabled}
                                              type="switch"
                                              name={`filters[${indexKey}].filters[${index}].isActive`}
                                              value={filter.isActive}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `filters[${indexKey}].filters[${index}].isActive`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </Td>
                                          <Td>
                                            <Flex>
                                              <Tooltip
                                                label="Delete Filter"
                                                hasArrow
                                                placement="left"
                                              >
                                                <Button
                                                  type="button"
                                                  size={"sm"}
                                                  mt="8px"
                                                  colorScheme="red"
                                                  variant="outline"
                                                  // size="sm"
                                                  onClick={() => remove(index)}
                                                  h="38px"
                                                  isDisabled={isDisabled}
                                                >
                                                  <DeleteIcon />
                                                </Button>
                                              </Tooltip>
                                              {index ===
                                                values.filters[indexKey].filters
                                                  .length -
                                                  1 && (
                                                <Tooltip
                                                  label="Add filter"
                                                  hasArrow
                                                  placement="left"
                                                >
                                                  <Button
                                                    bg="teal.400"
                                                    color="white"
                                                    size={"sm"}
                                                    _hover={{
                                                      bg: "teal.500",
                                                    }}
                                                    ml={5}
                                                    h="38px"
                                                    mt="8px"
                                                    // title="Add Filter"
                                                    onClick={() => {
                                                      setFieldValue(
                                                        `filters[${indexKey}].filters`,
                                                        [
                                                          ...values.filters[
                                                            indexKey
                                                          ].filters,
                                                          {
                                                            label: "",
                                                            key: "",
                                                            isActive: true,
                                                          },
                                                        ]
                                                      );
                                                    }}
                                                    isDisabled={isDisabled}
                                                  >
                                                    <FaPlus />
                                                  </Button>
                                                </Tooltip>
                                              )}
                                            </Flex>
                                          </Td>
                                        </Tr>
                                      )
                                    )}
                                  </Tbody>
                                </TableLoader>
                              )}
                            </FieldArray>
                          </Table>
                        </Box>
                        <Flex
                          justifyContent="end"
                          display={
                            values?.filters[indexKey].addNew
                              ? undefined
                              : "none"
                          }
                        >
                          <Box>
                            <Button
                              bg="green.400"
                              color="white"
                              _hover={{ bg: "green.500" }}
                              mt={4}
                              isLoading={settingCreateLoading}
                              onClick={() =>
                                createWorkflowSettings(
                                  indexKey,
                                  "filters",
                                  values,
                                  setFieldValue
                                )
                              }
                            >
                              Save
                            </Button>
                          </Box>
                        </Flex>
                      </Box>
                    </AccordionPanel>
                  </AccordionItem>
                </Accordion>
              ))}
            </Box>
          )}
        </FieldArray>
      </Box>
      {/* Define the Date Filters */}

      <Box shadow={"base"} p={4} mt={4} rounded={8} borderWidth={1}>
      <Text mb={2} color={'teal'} fontWeight={700}>
        Define Date Filters
      </Text>
        <Grid columnGap={5} rowGap={4} templateColumns={{ md: "1fr 1fr" }}>
          <CustomInput
            type="select"
            label="Filter Key"
            name="dateFilter.filterKey"
            placeholder="Enter the Filter Key"
            value={values.dateFilter.filterKey}
            options={dateFilter}
            onChange={(e) => {
              setFieldValue("dateFilter.filterKey", e);
            }}
            showError={showError}
            disabled={isDisabled}
            isBoxSelect={true}
          />
          {/* {values.dateFilter.rangeActive === true && ( */}
          <>
            <CustomInput
              type="select"
              label="Select Date Range"
              name="dateFilter.range"
              placeholder="Enter the name"
              value={values.dateFilter.range}
              options={dateRanges}
              onChange={(e) => {
                setFieldValue(`dateFilter.range`, e);
              }}
              showError={showError}
              disabled={isDisabled}
              isBoxSelect={true}
            />
          </>
          {/* )} */}
        </Grid>
        <Grid
          columnGap={5}
          rowGap={4}
          templateColumns={{ md: "1fr 1fr" }}
          mt={4}
        >
          <Grid
            columnGap={5}
            rowGap={4}
            templateColumns={{ md: "1fr 1fr 1fr" }}
          >
            <CustomInput
              disabled={isDisabled}
              type="switch"
              name="dateFilter.showFilter"
              label="Show Date Filter"
              value={values.dateFilter.showFilter}
              onChange={(e: any) =>
                setFieldValue(`dateFilter.showFilter`, e.target.checked)
              }
            />

            <CustomInput
              disabled={isDisabled}
              type="switch"
              name="dateFilter.rangeActive"
              label="Apply Date Range"
              value={values.dateFilter.rangeActive}
              onChange={(e: any) =>
                setFieldValue(`dateFilter.rangeActive`, e.target.checked)
              }
            />

            <CustomInput
              disabled={isDisabled}
              type="switch"
              name="dateFilter.rangePicker"
              label="Use Date Range Picker"
              value={values.dateFilter.rangePicker}
              onChange={(e: any) =>
                setFieldValue(`dateFilter.rangePicker`, e.target.checked)
              }
            />
          </Grid>
        </Grid>
      </Box>
      <Box shadow={"base"} p={4} mt={4} rounded={8} borderWidth={1}>
        <Text color={'teal'}  fontWeight="700" mb={2}>
          Sort By
        </Text>
        {values.sortBy?.length === 0 && (
          <Tooltip label="Add Sorting Option" hasArrow placement="left">
            <Button
              bg="teal.400"
              color="white"
              _hover={{
                bg: "teal.500",
              }}
              ml={5}
              h="38px"
              mt="8px"
              // title="Add Filter"
              onClick={() => {
                setFieldValue("sortBy", [
                  ...values.sortBy,
                  {
                    key: "",
                    mode: sortBy[1],
                    isActive: false,
                  },
                ]);
              }}
              isDisabled={isDisabled}
            >
              <FaPlus />
            </Button>
          </Tooltip>
        )}

        <Box className="customScrollBar" overflowY="auto">
          <Table variant="simple">
            <Thead>
              <Tr>
                <Th>Sort Mode</Th>
                <Th>Keys</Th>
                <Th>Active Mode</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <FieldArray name={"sortBy"}>
              {({ remove }) => (
                <TableLoader loader={false} show={values?.sortBy?.length}>
                  <Tbody>
                    {Array.from(
                      { length: values?.sortBy?.length },
                      (_, index) => (
                        <Tr key={index}>
                          <Td>
                            <CustomInput
                              type="select"
                              // label="Select Mode"
                              name={`values.sortBy[${index}].mode`}
                              value={values.sortBy[index].mode}
                              placeholder="Select Sort Mode"
                              options={sortBy}
                              onChange={(e: any) =>
                                setFieldValue(`sortBy[${index}].mode`, e)
                              }
                              disabled={isDisabled}
                              rest={{
                                width: {
                                  base: "10rem",
                                  lg: "100%",
                                },
                              }}
                              isBoxSelect={true}
                            />
                          </Td>
                          <Td>
                            <CustomInput
                              type="select"
                              name={`values.sortBy[${index}].key`}
                              value={values.sortBy[index].key}
                              placeholder="Select Sorting key"
                              options={schemaField}
                              onChange={(e: any) =>
                                setFieldValue(`sortBy[${index}].key`, e)
                              }
                              disabled={isDisabled}
                              rest={{
                                width: {
                                  base: "10rem",
                                  lg: "100%",
                                },
                              }}
                              isBoxSelect={true}
                            />
                          </Td>
                          <Td>
                            <CustomInput
                              disabled={isDisabled}
                              type="switch"
                              name={`values.sortBy[${index}].isActive`}
                              value={values.sortBy[index].isActive}
                              onChange={(e: any) =>
                                setFieldValue(
                                  `sortBy[${index}].isActive`,
                                  e.target.checked
                                )
                              }
                            />
                          </Td>
                          <Td>
                            <Flex>
                              <Tooltip
                                label="Delete Sorting Option"
                                hasArrow
                                placement="left"
                              >
                                <Button
                                  type="button"
                                  mt="8px"
                                  colorScheme="red"
                                  variant="outline"
                                  // size="sm"
                                  onClick={() => remove(index)}
                                  h="38px"
                                  isDisabled={isDisabled}
                                >
                                  <DeleteIcon />
                                </Button>
                              </Tooltip>
                              {index === values.sortBy.length - 1 && (
                                <Tooltip
                                  label="Add Sorting Option"
                                  hasArrow
                                  placement="left"
                                >
                                  <Button
                                    bg="teal.400"
                                    color="white"
                                    _hover={{
                                      bg: "teal.500",
                                    }}
                                    ml={5}
                                    h="38px"
                                    mt="8px"
                                    // title="Add Filter"
                                    onClick={() => {
                                      setFieldValue("sortBy", [
                                        ...values.sortBy,
                                        {
                                          key: "",
                                          mode: sortBy[1],
                                          isActive: false,
                                        },
                                      ]);
                                    }}
                                    isDisabled={isDisabled}
                                  >
                                    <FaPlus />
                                  </Button>
                                </Tooltip>
                              )}
                            </Flex>
                          </Td>
                        </Tr>
                      )
                    )}
                  </Tbody>
                </TableLoader>
              )}
            </FieldArray>
          </Table>
        </Box>
        <Grid templateColumns={{ md: "1fr 1fr" }} columnGap={5}></Grid>
      </Box>
    </Box>
  );
};

export default DefineSettings;
